<template>
	<teleport to="body">
		<div class="modal-mask" v-if="visible" @click="handleMaskClick()">
			<div class="modal-container" @click.stop>
				<div class="modal-header">
					<span>{{ isBatch ? '批量打印（' + orderList.length + '单）' : title }}</span>
					<button @click="handleClose()">×</button>
				</div>
				<div class="modal-body" style="width: 40vw;height: auto;">
					<div style="margin: 3% 14% 0% 7%;">
						<div v-if="isBatch" style="margin-bottom: 4%; color: #606266; font-size: 0.95em;">
							已选 {{ orderList.length }} 单：待取号 {{ batchCreateOrders.length }} 单
							<span v-if="orderList.length > batchCreateOrders.length">，重打 {{ orderList.length - batchCreateOrders.length }} 单</span>
						</div>
						<el-form :model="printForm" :rules="printRules" ref="printForm" label-width="6em">
							<!-- 电子面单选择：仅在需要取号或批量且有新单时显示 -->
							<el-form-item v-if="isBatch ? batchCreateOrders.length > 0 : !isReprint" label="电子面单" prop="expressAccountId">
								<el-select v-model="printForm.expressAccountName" value-key="id"
									@change="selectExpressAccount" placeholder="请选择电子面单" :loading="accountLoading"
									style="width: 100%;">
									<el-option v-for="item in express_account_list" :key="item.id"
										:label="item.nickname+'（余额：'+item.quota+')'" :value="item">
										<span style="float: left;position: relative;left: -2%;">{{ item.nickname }}</span>
										<span style="float: right; color: #2ea2e0; font-size: 0.9em">{{ item.quota }}</span>
									</el-option>
								</el-select>
							</el-form-item>
							
							<el-form-item label="打印机" prop="printer">
								<el-select v-model="printForm.printer" :loading="printLoading"
									@visible-change="getLocal_kb_Printer()" placeholder="请选择打印机" style="width: 100%;">
									<el-option v-for="i in printerList" :key="i.name" :label="i.name" :value="i.name">
										<span style="float: left">{{ i.name }}</span>
									</el-option>
								</el-select>
							</el-form-item>
							
							<!-- 打印模板：固定显示，禁用选择，实际ID由代码自动匹配 -->
							<el-form-item label="打印模板">
								<el-input v-model="fixedTemplateName" disabled placeholder="标准一联单" style="width: 100%;"></el-input>
							</el-form-item>

							<el-form-item v-if="isBatch" style="margin-top: 10%;margin-bottom: 8%;">
								<el-button type="primary" @click="handlePrintAction('batch')" :disabled="printingProgress == true" style="margin-left: 34%;">批量打印</el-button>
							</el-form-item>
							<el-form-item v-if="!isBatch" style="margin-top: 10%;margin-bottom: 8%;">
								<el-button plain @click="handlePrintAction('getWaybill')" style="margin-left: 6%;"
									:disabled="orderContent['orderStatusCode']!='CREATE' || printingProgress == true">仅获取运单</el-button>
								<el-button type="primary" @click="handlePrintAction('print')"
									:disabled="printingProgress == true" style="margin-left: 18%;">打印面单</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</teleport>
</template>

<script>
	import {
		ElMessage,
		ElButton,
		ElForm,
		ElFormItem,
		ElSelect,
		ElOption,
		ElInput,
		ElLoading
	} from 'element-plus'
	import apiService from "../../../../src/util/apiService.js"
	
	export default {
		components: {
			ElButton, ElForm, ElFormItem, ElSelect, ElOption, ElInput
		},
		props: {
			visible: { type: Boolean, default: false },
			title: { type: String, default: '运单打印' },
			orderContent: { type: Object, default: null },
			orderList: { type: Array, default: null },
			isReprint: { type: Boolean, default: false }
		},
		data() {
			return {
				fixedTemplateName: '标准一联单', // 固定显示的文本
				orderNo: null,
				kbPrinter: null,
				printerList: [],
				printForm: {
					expressAccountId: '', 
					expressAccountName: '', 
					cpCode: '', 
					printer: '', 
				},
				express_account_list: [],
				accountLoading: false,
				printLoading: false,
				// 快递公司代码到标准一联单模板ID的映射
				printTemplateList: {
					'ZTO': { templateName: '中通标准一联单', templateId: '666705' },
					'YTO': { templateName: '圆通标准一联单', templateId: '666838' },
					'JT':  { templateName: '极兔标准一联单', templateId: '666725' },
					'SF':  { templateName: '顺丰标准一联单', templateId: '666849' },
					'YD':  { templateName: '韵达标准一联单', templateId: '666839' },
					'STO': { templateName: '申通标准一联单', templateId: '666703' }
				},
				printRules: {
					expressAccountId: [{ required: true, message: '请选择电子面单账户', trigger: 'change' }]
				},
				isConnected: false, 
				isObtainedWaybill: false,
				printingProgress: false,
				// 批量打印状态追踪
				batchPendingOrderNos: [],
				batchSuccessCount: 0,
				batchFailMsgs: [],
				batchReceiptTimer: null
			}
		},
		computed: {
			isBatch() {
				return Array.isArray(this.orderList) && this.orderList.length > 0;
			},
			batchCreateOrders() {
				if (!this.isBatch) return [];
				return this.orderList.filter(o => o.orderStatusCode == 'CREATE');
			},
			batchCpCodes() {
				if (!this.isBatch) return [];
				var cpSet = {};
				this.orderList.forEach(o => {
					var cp = o.orderStatusCode == 'CREATE' ? (this.printForm.cpCode || '') : o.cpCode;
					if (cp) cpSet[cp] = true;
				});
				return Object.keys(cpSet);
			}
		},
		mounted() {
			if (this.visible) {
				this.initPrintForm();
				this.getExpressAccountList();
				this.connect_Kb_Printer();
			}
		},
		methods: {
			// 初始化表单数据
			initPrintForm() {
				try {
					var savedPrintForm = JSON.parse(localStorage.getItem('printForm'));
					if (savedPrintForm) {
						this.printForm.printer = savedPrintForm.printer;
						if (this.isBatch && this.batchCreateOrders.length > 0) {
							this.printForm.expressAccountId = savedPrintForm.expressAccountId;
							this.printForm.expressAccountName = savedPrintForm.expressAccountName;
							this.printForm.cpCode = savedPrintForm.cpCode;
						} else if (!this.isBatch) {
							if (this.orderContent["orderStatusCode"] == "CREATE") {
								this.printForm.expressAccountId = savedPrintForm.expressAccountId;
								this.printForm.expressAccountName = savedPrintForm.expressAccountName;
							}
							if (this.orderContent["cpCode"] == savedPrintForm["cpCode"]) {
								this.printForm.cpCode = savedPrintForm.cpCode;
							}
							if (this.orderContent["orderStatusCode"] == "CREATE") {
								this.printForm.cpCode = savedPrintForm.cpCode;
							}
						}
					}
				} catch (e) {
					console.log("读取默认打印设置失败", e);
				}
				
				if (this.isReprint && !this.isBatch) {
					this.printForm['cpCode'] = this.orderContent['cpCode'];
				}
			},

			// 统一入口：处理点击事件
			async handlePrintAction(actionType) {
				localStorage.setItem('printForm', JSON.stringify(this.printForm));
				
				// 基础校验
				if (!this.printForm['printer']) {
					ElMessage.error('请选择打印机');
					return;
				}
				
				if (actionType === 'batch') {
					if (this.batchCreateOrders.length > 0 && !this.printForm.expressAccountId) {
						ElMessage.error('请选择电子面单');
						return;
					}
					// 校验所有涉及的快递公司是否有配置标准模板
					var cpCodes = this.batchCpCodes;
					for (var i = 0; i < cpCodes.length; i++) {
						if (!this.printTemplateList[cpCodes[i]]) {
							ElMessage.error('快递公司 ' + cpCodes[i] + ' 未配置标准一联单模板');
							return;
						}
					}
					this.executeBatchPrint();
				} else {
					// 单张打印逻辑
					if (!this.orderContent) {
						ElMessage.error('订单信息不存在');
						return;
					}
					
					if (actionType === 'getWaybill') {
						if (this.orderContent['orderStatusCode'] !== 'CREATE') {
							ElMessage.warning('该订单已取号，无需重复获取');
							return;
						}
						this.executeSingleWaybillFetch(this.orderContent);
					} else if (actionType === 'print') {
						// 打印前再次确认CP代码是否有效
						const currentCp = this.orderContent.cpCode || this.printForm.cpCode;
						if (!currentCp || !this.printTemplateList[currentCp]) {
							ElMessage.error('无法识别快递公司或该快递未配置标准模板');
							return;
						}
						this.executeSinglePrint(this.orderContent);
					}
				}
			},

			// 核心逻辑：执行单张取号
			async executeSingleWaybillFetch(order) {
				this.printingProgress = true;
				this.orderNo = order.orderNo;
				try {
					const waybillData = await this.fetchWaybillFromApi(order.orderNo, this.printForm.expressAccountId);
					if (!waybillData) {
						ElMessage.error("运单获取失败");
						this.printingProgress = false;
						return;
					}
					
					order["waybillNo"] = waybillData["waybillNo"];
					order["sortInfo"] = this.buildSortInfo(waybillData);
					
					if (waybillData.cpCode == "YTO") {
						this.subscribeWaybill(waybillData.cpCode, waybillData.waybillNo);
					}

					ElMessage({ message: '取号成功', type: 'success' });
					location.reload(); 
				} catch (e) {
					console.error("取号异常", e);
					ElMessage.error("取号异常");
				} finally {
					this.printingProgress = false;
				}
			},

			// 核心逻辑：执行单张打印
			async executeSinglePrint(order) {
				this.printingProgress = true;
				this.orderNo = order.orderNo;
				let currentOrder = { ...order };

				try {
					// 如果需要取号
					if (currentOrder.orderStatusCode == "CREATE") {
						const waybillData = await this.fetchWaybillFromApi(currentOrder.orderNo, this.printForm.expressAccountId);
						if (!waybillData) {
							ElMessage.error("运单获取失败");
							this.printingProgress = false;
							return;
						}
						currentOrder["waybillNo"] = waybillData["waybillNo"];
						currentOrder["sortInfo"] = this.buildSortInfo(waybillData);
						currentOrder["cpCode"] = waybillData.cpCode || this.printForm.cpCode;
						
						if (waybillData.cpCode == "YTO") {
							this.subscribeWaybill(waybillData.cpCode, waybillData.waybillNo);
						}
					}

					// 确定最终使用的 CP Code
					const finalCpCode = currentOrder.cpCode || this.printForm.cpCode;
					// 发送打印指令，模板ID在 sendPrintCommand 中自动匹配
					this.sendPrintCommand([currentOrder], finalCpCode);
				} catch (e) {
					console.error("打印异常", e);
					this.printingProgress = false;
				}
			},

			// 核心逻辑：执行批量打印
			async executeBatchPrint() {
				this.printingProgress = true;
				let loading = null;
				
				try {
					loading = ElLoading.service({
						lock: true,
						text: '批量获取运单中…',
						background: 'rgba(0, 0, 0, 0.7)',
					});

					const createOrders = this.batchCreateOrders.slice();
					for (let order of createOrders) {
						const waybillData = await this.fetchWaybillFromApi(order.orderNo, this.printForm.expressAccountId);
						if (!waybillData) {
							throw new Error(`订单 ${order.orderNo} 取号失败`);
						}
						order.waybillNo = waybillData.waybillNo;
						order.cpCode = waybillData.cpCode || this.printForm.cpCode;
						order.sortInfo = this.buildSortInfo(waybillData);
						this.orderStatusUpdate(order.orderNo, 'GET_WAYBILL');
					}

					loading.close();
					loading = null;

					if (!this.isConnected) {
						ElMessage.error('快宝打印组件未连接成功，取号已完成，请连接组件后重新打印');
						this.printingProgress = false;
						return;
					}

					// 分组并发送打印指令
					const groups = {};
					this.orderList.forEach(o => {
						const cp = (o.orderStatusCode == 'CREATE' && this.printForm.cpCode) ? this.printForm.cpCode : o.cpCode;
						if (!groups[cp]) groups[cp] = [];
						groups[cp].push(o);
					});

					// 【重要修复】确保 batchPendingOrderNos 中的订单号全部转为字符串，以便与 WebSocket 返回的 JSON Key (String) 匹配
					this.batchPendingOrderNos = this.orderList.map(o => String(o.orderNo));
					this.batchSuccessCount = 0;
					this.batchFailMsgs = [];
					if (this.batchReceiptTimer) clearTimeout(this.batchReceiptTimer);
					
					this.batchReceiptTimer = setTimeout(() => {
						if (this.batchPendingOrderNos.length > 0) {
							this.batchPendingOrderNos = [];
							this.printingProgress = false;
							ElMessage.warning('打印组件回执超时，请到订单列表确认打印状态');
						}
						this.batchReceiptTimer = null;
					}, 90000);

					// 按CP发送打印请求
					for (const cp in groups) {
						const templateObj = this.printTemplateList[cp];
						if (!templateObj) continue; 

						const printDataItems = groups[cp].map(o => this.buildPrintDataItem(o, cp));
						
						const param = {
							"cmd": "print",
							"requestID": String(new Date().getTime()) + "_" + cp,
							"version": "1.0",
							"printer_name": this.printForm['printer'],
							"print_type": 2,
							"private": 1,
							"template_id": templateObj.templateId, // 自动匹配的模板ID
							"user_name": "掌递宝",
							"print_data": printDataItems
						};
						
						this.send_kb_PrinterMsg(JSON.stringify(param));
					}

					ElMessage({
						message: `已发送打印指令，共 ${this.orderList.length} 单，等待打印回执…`,
						type: 'info',
					});

				} catch (e) {
					console.error("批量打印异常", e);
					ElMessage.error(e.message || "批量打印异常");
					this.printingProgress = false;
				} finally {
					if (loading) loading.close();
				}
			},

			// 辅助：API获取运单
			async fetchWaybillFromApi(orderNo, expressAccountId) {
				if (this.isObtainedWaybill && !this.isBatch) {
					ElMessage.error('打印锁定，请刷新后再试');
					return null;
				}
				this.isObtainedWaybill = true;
				
				try {
					const res = await apiService.post({
						modules: "getWaybill",
						content: { orderNo, expressAccountId }
					});
					return res.status ? res.data : null;
				} catch (e) {
					console.error("获取运单API异常", e);
					return null;
				} finally {
					if(!this.isBatch) this.isObtainedWaybill = false;
				}
			},

			buildSortInfo(waybillData) {
				return {
					assemblyPointCode: waybillData["assemblyPointCode"] || "",
					assemblyPointName: waybillData["assemblyPointName"] || "",
					belongOrgCode: "",
					belongOrgName: "",
					destAddressKeyWord: "",
					productCode: "",
					qrCode: "",
					sortingCode: waybillData["sortingCode"] || ""
				};
			},

			buildPrintDataItem(orderContent, cpCode) {
				const sortInfo = orderContent["sortInfo"] || {};
				return {
					"tid": orderContent['orderNo'],
					"waybill_code": orderContent['waybillNo'],
					"cp_code": cpCode,
					"sender": {
						"address": {
							"province": orderContent['sender']['provinceName'],
							"city": orderContent['sender']['cityName'],
							"district": orderContent['sender']['districtName'],
							"detail": orderContent['sender']['address']
						},
						"mobile": orderContent['sender']['mobile'],
						"name": orderContent['sender']['name'],
						"phone": ""
					},
					"recipient": {
						"address": {
							"province": orderContent['recipient']['provinceName'],
							"city": orderContent['recipient']['cityName'],
							"district": orderContent['recipient']['districtName'],
							"detail": orderContent['recipient']['address']
						},
						"mobile": orderContent['recipient']['mobile'],
						"name": orderContent['recipient']['name'],
						"phone": ""
					},
					"routing_info": {
						"consolidation": {
							"name": sortInfo['assemblyPointName'],
							"code": sortInfo['assemblyPointCode']
						},
						"sortation": {
							"name": sortInfo['sortingCode']
						}
					},
					"note": orderContent['remark'],
					"package": orderContent['goods'] ? orderContent['goods'][0] : null
				};
			},

			// 辅助：发送打印命令（通用）
			sendPrintCommand(orders, cpCode) {
				if (!this.isConnected) {
					ElMessage.error('快宝打印组件未连接成功');
					this.printingProgress = false;
					return;
				}

				// 自动匹配模板ID
				const templateObj = this.printTemplateList[cpCode];
				if (!templateObj) {
					ElMessage.error('未找到该快递公司的标准模板配置: ' + cpCode);
					this.printingProgress = false;
					return;
				}

				const printDataItems = orders.map(o => this.buildPrintDataItem(o, cpCode));
				
				const param = {
					"cmd": "print",
					"requestID": String(new Date().getTime()),
					"version": "1.0",
					"printer_name": this.printForm['printer'],
					"print_type": 2,
					"private": 1,
					"template_id": templateObj.templateId, // 使用自动匹配的ID
					"user_name": "掌递宝",
					"print_data": printDataItems
				};
				
				this.send_kb_PrinterMsg(JSON.stringify(param));
			},

			subscribeWaybill(cpCode, waybillNo) {
				apiService.post({
					modules: "subscriptionWaybill",
					content: { cpCode, waybillNo, phone: "" }
				}).catch(e => console.log(e));
			},

			// WebSocket 相关
			connect_Kb_Printer() {
				if (this.kbPrinter) {
					this.kbPrinter.close();
					this.kbPrinter = null;
					this.isConnected = false;
				}
				if (!window.WebSocket) {
					alert('当前浏览器不支持WebSocket！');
					return;
				}
				this.kbPrinter = new WebSocket("ws://localhost:13628");
				this.kbPrinter.onopen = () => {
					this.isConnected = true;
					console.log('WebSocket已连接');
				};
				this.kbPrinter.onmessage = (e) => {
					const resMsg = JSON.parse(e.data);
					console.log('收到消息：', resMsg);
					
					if (resMsg.cmd == "getPrinters") {
						this.printerList = resMsg.printers || [];
					} else if (resMsg.cmd == "print") {
						this.handlePrintResponse(resMsg);
					}
				};
				this.kbPrinter.onclose = () => {
					this.isConnected = false;
					console.log('WebSocket已断开');
				};
				this.kbPrinter.onerror = (err) => {
					ElMessage.error('快宝打印组件连接失败');
					this.isConnected = false;
					this.handleClose();
					console.error('WebSocket错误：', err);
				};
			},
			
			getLocal_kb_Printer() {
				if (!this.isConnected) return;
				const data = JSON.stringify({
					"cmd": "getPrinters",
					"requestID": String(new Date().getTime()),
					"version": "1.0",
					"getStatus": "true"
				});
				this.send_kb_PrinterMsg(data);
			},

			send_kb_PrinterMsg(sendText) {
				if (!this.isConnected) {
					ElMessage.error('快宝打印组件未连接成功');
					return;
				}
				try {
					this.kbPrinter.send(sendText.trim());
				} catch (err) {
					console.error('发送失败：', err);
				}
			},

			handlePrintResponse(resMsg) {
				if (this.isBatch) {
					this.handleBatchPrintResult(resMsg);
				} else {
					this.handleSinglePrintResult(resMsg);
				}
			},

			handleSinglePrintResult(resMsg) {
				const orderNo = this.orderNo;
				if (resMsg[orderNo]) {
					const result = resMsg[orderNo];
					if (result.status == 'success') {
						this.orderStatusUpdate(orderNo, 'PRINT');
						ElMessage({ message: '打印完成', type: 'success' });
						location.reload();
					} else {
						ElMessage({
							message: '打印失败: ' + (result.message || '未知错误'),
							type: 'error',
						});
						this.printingProgress = false;
					}
				}
			},

			handleBatchPrintResult(resMsg) {
				let hasUpdate = false;
				for (const key in resMsg) {
					// 【重要修复】跳过非订单号的字段（如 result, cmd, requestID）
					// 并且确保 key 是我们在 batchPendingOrderNos 中存储的格式（String）
					if (!this.batchPendingOrderNos.includes(key)) {
						continue;
					}
					
					const item = resMsg[key];
					// 确保 item 是一个对象且包含 status 字段，避免处理到非订单数据
					if (item && typeof item === 'object' && item.status) {
						if (item.status == 'success') {
							this.batchSuccessCount++;
							this.orderStatusUpdate(key, 'PRINT');
						} else {
							this.batchFailMsgs.push(key + (item.message ? ('：' + item.message) : ''));
						}
					}
					
					// 从待处理列表中移除
					const index = this.batchPendingOrderNos.indexOf(key);
					if (index > -1) {
						this.batchPendingOrderNos.splice(index, 1);
						hasUpdate = true;
					}
				}

				if (hasUpdate && this.batchPendingOrderNos.length === 0) {
					this.finishBatchPrint();
				}
			},

			finishBatchPrint() {
				this.printingProgress = false;
				if (this.batchReceiptTimer) {
					clearTimeout(this.batchReceiptTimer);
					this.batchReceiptTimer = null;
				}

				if (this.batchFailMsgs.length == 0) {
					ElMessage({
						message: '批量打印完成，共' + this.batchSuccessCount + '单',
						type: 'success',
					});
				} else {
					ElMessage({
						message: '打印结束：成功' + this.batchSuccessCount + '单，失败' + this.batchFailMsgs.length + '单（' + this.batchFailMsgs.join('；') + '）',
						type: 'error',
						duration: 8000,
					});
				}
				location.reload();
			},

			selectExpressAccount(item) {
				this.printForm.expressAccountId = item['id'];
				this.printForm.cpCode = item['cpCode'];
				this.printForm.expressAccountName = item.nickname + '（余额：' + item.quota + '）';
			},

			getExpressAccountList() {
				apiService.post({ modules: "getExpressAccountList", content: {} })
					.then((res) => {
						if (res.status) {
							this.express_account_list = res.data.expressAccountList;
						}
					});
			},

			orderStatusUpdate(orderNo, statusCode) {
				apiService.post({
					modules: "upOrderStatus",
					content: { orderNo, statusCode }
				}).catch(e => console.log("订单状态更新失败", orderNo, e));
			},

			handleMaskClick() {
				this.handleClose();
			},
			handleClose() {
				this.$emit('close');
			}
		},
		watch: {
			visible(newVal) {
				if (newVal) {
					this.initPrintForm();
					this.getExpressAccountList();
					this.connect_Kb_Printer();
				}
			}
		}
	}
</script>

<style scoped>
	.modal-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 2;
	}

	.modal-container {
		background: white;
		border-radius: 8px;
		max-height: 80vh;
		display: flex;
		flex-direction: column;
	}

	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #eee;
		padding-bottom: 8px;
		flex-shrink: 0;
		background-color: #007aff;
		padding: 10px;
		color: #fff;
		border-radius: 8px 8px 0 0;
	}

	.modal-header span {
		position: relative;
		width: 100%;
		text-align: center;
		font-size: 1.1em;
		font-family: sans-serif;
		font-weight: 400;
	}

	.modal-header button {
		background: transparent;
		border: none;
		font-size: 1.5em;
		cursor: pointer;
		color: #fff;
		position: relative;
		right: 2%;
	}

	.modal-body {
		flex: 1;
		overflow-y: auto;
		margin: 20px;
	}
</style>
<style>
	.modal-body::-webkit-scrollbar {
		width: 3px !important;
		height: 3px !important;
	}
	.modal-body::-webkit-scrollbar-button {
		display: none !important;
	}
	.modal-body::-webkit-scrollbar-track {
		background: transparent !important;
		border-radius: 3px !important;
	}
	.modal-body::-webkit-scrollbar-thumb {
		background: rgba(224, 224, 224, 0.3) !important;
		border-radius: 3px !important;
		border: none !important;
	}
	.modal-body::-webkit-scrollbar-thumb:hover {
		background: rgba(224, 224, 224, 0.3) !important;
	}
	.modal-body {
		scrollbar-width: thin !important;
		scrollbar-color: rgba(224, 224, 224, 0.3) transparent !important;
	}
</style>